// Routes + the identity gate. /me decides whether the shell renders at all:
// without Cloudflare Access (or as a non-admin) the console shows nothing
// but a short explanation.

import { BrowserRouter, Route, Routes } from "react-router-dom";
import type { AdminMe } from "@paceroo/domain/views/admin";
import { useAdminQuery } from "./lib/api";
import { Assistants } from "./screens/Assistants";
import { Audit } from "./screens/Audit";
import { Events } from "./screens/Events";
import { Exports } from "./screens/Exports";
import { NotFound } from "./screens/NotFound";
import { Overview } from "./screens/Overview";
import { Runner } from "./screens/Runner";
import { Runners } from "./screens/Runners";
import { AccessGate, Shell } from "./shell/Shell";

export function AdminApp() {
  const me = useAdminQuery<AdminMe>("me");
  if (me.error) return <AccessGate status={me.error.status} message={me.error.message} />;
  if (!me.data)
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }} aria-busy="true">
        <span className="pa-spinner" style={{ width: 16, height: 16 }} />
      </div>
    );
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell me={me.data} />}>
          <Route index element={<Overview />} />
          <Route path="runners" element={<Runners />} />
          <Route path="runners/:id" element={<Runner />} />
          <Route path="exports" element={<Exports />} />
          <Route path="assistants" element={<Assistants />} />
          <Route path="events" element={<Events />} />
          <Route path="audit" element={<Audit />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
